import React, { useEffect, useState, useCallback, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";

import { Component } from "react";
import { getAlertData, resetMessageCount } from "@/api/alerts";
import {
  checkSmsFeatureEnabled,
  checkLoginStatus,
  saveUserDetails,
  isIdologyVerificationRequired,
  getUserProfile,
  getCitiesByState,
  getLicenseDetails,
  insertUserLicense,
  deleteLicense,
  getAllLicenseDetails,
  updateUserLicense,
  getUserProfileVerificationDetails,
  sendEmailLink,
} from "@/api/myProfile";
import ProgressBar from "react-bootstrap/ProgressBar";
import { Button, Form, Container, Row, Col, Table } from "react-bootstrap";
import InputField from "@/components/common/InputField/InputField";
import IdologyVerification from "@/components/IdologyVerification/IdologyVerification";
import "./Alerts.css";
import { FaPlus } from "react-icons/fa";
import DynamicModal from "@/components/user/My Profile/DynamicModal/DynamicModal";
import LicenseInfoTable from "./LicenseInfoTable";
import AlertsCards from "./AlertsCards";
import FlatList from "flatlist-react";
import LoginSignup from "@/components/common/user-credentials/LoginSignup";
import { HiOutlineBellAlert } from "react-icons/hi2";
import { validateForm } from "@/utils/formValidator";
import { setLoginCallLocation, setLoginTab } from "@/redux/login/loginSlice";

import { setAlerts, setProfileInfo, setAlertsCount } from "@/redux/user/userSlice";
import { verifyUserProfile, getLicenseAddressRequiredStateList } from "@/api/LoginSignup";
import { formatDisplayDate, parseDateString } from "@/utils/dateFormatter";

import { trackEvent } from "@/utils/analytics";

import { verifyLicenseDetails } from "@/api/bid";
import { Modal } from "react-bootstrap";
import {
  deleteCorporateLicence,
  editCorporateDetail,
  insertCorporateLicence,
  isPhoneNoInUse,
  updateCorporateLicence,
} from "@/api/bid";
import IdologyQuestions from "@/components/IdologyVerification/IdologyQuestions";
import { store } from "@/store/store";
import { AgentLiecenseErrorMsgs } from "@/setting";
import { initializeApp, getApps } from "firebase/app";
import { getDatabase, ref, onValue, onChildAdded, onChildChanged, off } from "firebase/database";
import {
  alertsSummary,
} from "@/api/LoginSignup";
import { doc, onSnapshot, collection } from "firebase/firestore";
import { inititaliseFirebase } from "@/components/common/FirebaseApp";
import { ToastContainer, toast } from 'react-toastify';
import Loader from "@/components/common/loader/Loader";
import { trackApiCall, trackButtonClick, trackPageMount } from "@/utils/analytics";
import { selectStateList } from "@/redux/common/commonSlice";
import { globalCmsData } from "@/redux/cms/cmsSelectors";
import { ShimmerContentBlock } from "react-shimmer-effects";

// import {
//     Form,
//     Button,
//     Container,
//     Row,
//     Col,
//     Card,
//     Alert,
//   } from "react-bootstrap";

const Alerts = () => {
  const stateList = useSelector(selectStateList);

  const [now, setNow] = useState(50);
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingAlerts, setIsLoadingAlerts] = useState(false);

  const [isIdologyVerified, setIsIdologyVerified] = useState(true);
  const [userDataLocal, setUserDataLocal] = useState();
  const [userType, setUserType] = useState();

  const [userRoles, setUserRoles] = useState([]);
  const [isSMSFeatureAvailable, setIsSMSFeatureAvailable] = useState("Y");
  const [licenses, setLicenses] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [submitUserForm, setUserSubmitForm] = useState(false);
  const [smsOptInStatus, setSMSOptInStatus] = useState("Yes");
  const [modalMode, setModalMode] = useState("");
  const [initialValues, setInitialValues] = useState(null);
  const [initalCorpValues, setInitialCorpValues] = useState(null);
  const firebaseConfig = useSelector((state) => state.user.firebaseConfig);
  const [ideologyFormErrors, setIdeologyFormErrors] = useState({});


  const [show, setShow] = useState(false);

  const [showConfirmation, setShowConfirmation] = useState(false);
  const [isUserLogggedInLocal, setIsUserLogggedInLocal] = useState(false);
  const state = store.getState();
  const alertsData = state?.user?.alertsData;
  const alerts = useSelector((state) => state?.user?.alerts);

  // const alertsData = useSelector((state) => state.user.alerts);
  const profileInfo = useSelector((state) => state.user.profileInfo);

  const userData = useSelector((state) => state?.user);
  const [ideologyError, setIdeologyError] = useState();
  const [remainingCount, setRemainingCount] = useState(null);
  const [dob, setDob] = useState(""); // React state for date of birth
  const [ssn, setSsn] = useState(""); // React state for SSN
  const [editingLicense, setEditingLicense] = useState(null);
  const [userProfileData, setUserProfileData] = useState(null);
  const [showIdolodyQuestions, setShowIdolodyQuestions] = useState(false)
  const [question, setQuestions] = useState([])
  const [licenseType, setLicenseType] = useState("Indv");
  const [licenseCityDropDowm, setLicenseCityDropDown] = useState("");
  const [remainingAttemptCount, setRemainingAttemptCount] = useState(null);
  const [emailSend, setEmailSend] = useState(false)
  const [showSendLink, setShowSendLink] = useState(false);


  const userID = state?.user?.user?.realbidUserId;

  const initialFetchDone = useRef(false);

  const dispatch = useDispatch();

  const handleShow = () => setShowConfirmation(true);
  const handleClose = () => setShowConfirmation(false);
  const [showLicenseTable, setShowLicenseTable] = useState(
    profileInfo?.role === "AGENT"
  );
  const [agentLicenseInfo, setAgentLicenseInfo] = useState([]);
  const [agentCorpLicenseInfo, setAgentCorpLicenseInfo] = useState([]);
  // console.log("agentLicenseInfo ->", agentLicenseInfo);
  const [licenseLoading, setLicenseLoading] = useState(false);

  const [formData, setFormData] = useState({
    firstName: profileInfo?.userDetails?.firstName || "",
    lastName: profileInfo?.userDetails?.lastName || "",
    emailId: profileInfo?.userDetails?.emailId || "",
    addressLine1: profileInfo?.userDetails?.address?.address1 || "",
    addressLine2: profileInfo?.userDetails?.address?.address2 || "",
    state: profileInfo?.userDetails?.address?.state || "",
    city: profileInfo?.userDetails?.address?.city || "",
    zipCode: profileInfo?.userDetails?.address?.zip || "",
    phoneNumber: profileInfo?.userDetails?.phoneNumber || "",
    userRoles: profileInfo?.userDetails?.userRoles || [],
    address: {
      address1: profileInfo?.userDetails?.address?.address1 || "",
      address2: profileInfo?.userDetails?.address?.address2 || "",
      city: profileInfo?.userDetails?.city || "",
      cityFromDropDown: false,
      state: profileInfo?.userDetails?.address?.city,
      zip: profileInfo?.userDetails?.address?.zip,
    },
    // userRoles: [],
    smsOptInStatus: null,
  });
  const [errorSubmitting, setErrorSubmitting] = useState("");
  const [licenseEmpty, setLicenseEmpty] = useState(true);

  const [cities, setCities] = useState([]);
  const [errors, setErrors] = useState({});
  const [isProfileComplete, setIsProfileComplete] = useState();
  const [maskedDuplicateEmailID, setMaskedDuplicateEmailID] = useState("")
  const globalData = useSelector(globalCmsData);



  // const citiesData = getCitiesByState(
  //   profileInfo?.userDetails?.address?.state
  // );
  // const cityArray = citiesData.data || citiesData;
  // const [cities, setCities] = useState(
  //   Array.isArray(cityArray) ? cityArray : []
  // );

  const fetchCitiesByState = async (state) => {
    if (!state) return;

    try {
      const citiesResponse = await getCitiesByState(state);
      const cityArray = citiesResponse.data || citiesResponse;
      setCities(Array.isArray(cityArray) ? cityArray : []);
    } catch (error) {
      console.error("Failed to fetch cities:", error);
      setCities([]);
    }
  };

  // useEffect - for general city fetching
  useEffect(() => {
    const state =
      licenseCityDropDowm || profileInfo?.userDetails?.address?.state;
    fetchCitiesByState(state);
  }, [licenseCityDropDowm, profileInfo?.userDetails?.address?.state]);

  // useEffect - for AGENT specific data
  useEffect(() => {
    // Only run for AGENT user type
    if (userType !== "AGENT") return;

    const fetchData = async () => {
      try {
        // Get user profile first
        await getUserProfile();

        // Run remaining requests in parallel
        const [licenseStatesResponse, allLicenseResponse] = await Promise.all([
          getLicenseAddressRequiredStateList(),
          getAllLicenseDetails(),
        ]);

        // Only fetch cities if state is defined
        if (formData.address.state) {
          const citiesResponse = await getCitiesByState(formData.address.state);
          const cityArray = citiesResponse.data || citiesResponse;
          setCities(Array.isArray(cityArray) ? cityArray : []);
        }

        // Set license information
        setAgentLicenseInfo(allLicenseResponse?.response?.INDV || []);
        setAgentCorpLicenseInfo(allLicenseResponse?.response?.CORP || []);
      } catch (error) {
        console.error("Error fetching agent data:", error);
      }
    };

    setShowLicenseTable(true);
    fetchData();
  }, [userType === "AGENT"]);


  const handleCorpLicenseFormSubmit = async (licenseData) => {
    try {
      if (modalMode == "Add") {
        setInitialCorpValues(null);
        setLicenseLoading(true);
        const data = await verifyLicenseDetails(
          licenseData?.licenceNumber,
          licenseData?.stateId
        );
        if (
          data?.verificationStatus === "LICENSE_FORMAT_NOT_OK" &&
          data?.inputStateId == "AL"
        ) {
          setErrorSubmitting(data?.licenseFormatDescription);
          setLicenseLoading(false);
        } else {
          setErrorSubmitting("");
          const response = await insertCorporateLicence(licenseData);
          if (response?.data?.status === "SUCCESS") {
            setShowModal(false);
            const allLicense = await getAllLicenseDetails();
            setAgentCorpLicenseInfo(allLicense?.response?.CORP || []);
            toast.success("License Added successfully", {
              closeOnClick: true,
              autoClose: 5000,
            });
            setLicenseLoading(false);

            trackApiCall({
              eventName: "add_license_click_success",
              eventCategory: "Profile Forms Global Alerts",
              eventLabel: "Agent",
            });
          } else {
            if (
              response?.data?.errorMessage === "VALIDATION_STATE_ZIP_FAILURE"
            ) {
              trackApiCall({
                eventName: "add_license_click_failure",
                eventCategory: `Error - License add Global Alerts - VALIDATION_STATE_ZIP_FAILURE`,
                eventSource: "on add license failure",
                eventLabel: "Agent",
              });
              setErrorSubmitting(
                "Provided zip code is not valid for selected state"
              );
            } else if (response?.data?.errorMessage === "STATE_LICENSE_ALREADY_EXIST") {
              setErrorSubmitting("A Corp License already exists for that state. You are allowed to only one Corp License for a State")
            }
            else {
              toast.error(response?.data?.errorMessage);
              setShowModal(false);
            }
          }
        }
      } else {
        setInitialCorpValues(null);
        setLicenseLoading(true);
        const data = await verifyLicenseDetails(
          licenseData?.licenceNumber,
          licenseData?.stateId
        );
        if (
          data?.verificationStatus === "LICENSE_FORMAT_NOT_OK" &&
          data?.inputStateId == "AL"
        ) {
          setErrorSubmitting(data?.licenseFormatDescription);
          setLicenseLoading(false);
        } else {
          setErrorSubmitting("");
          const response = await updateCorporateLicence(licenseData);
          if (response?.data?.status === "SUCCESS") {
            trackApiCall({
              eventName: "update_license_click_success",
              eventCategory: "Profile Forms Global Alerts",
              eventLabel: "Agent",
            });
            const allLicense = await getAllLicenseDetails();
            setAgentCorpLicenseInfo(allLicense?.response?.CORP || []);
            toast.success("License updated successfully", {
              closeOnClick: true,
              autoClose: 5000,
            });
            setLicenseLoading(false);
          } else {
            if (
              response?.data?.errorMessage === "VALIDATION_STATE_ZIP_FAILURE"
            ) {
              trackApiCall({
                eventName: "update_license_click_failure",
                eventCategory: `Error - License update Global Alerts - VALIDATION_STATE_ZIP_FAILURE`,
                eventSource: "on update license failure",
                eventLabel: "Agent",
              });
              setErrorSubmitting(
                "Provided zip code is not valid for selected state"
              );
            }
            else if (response?.data?.errorMessage === "STATE_LICENSE_ALREADY_EXIST") {
              setErrorSubmitting("A Corp License already exists for that state. You are allowed to only one Corp License for a State")
            } else {
              toast.error(response?.data?.errorMessage);
              setShowModal(false);
            }
          }
        }
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLicenseLoading(false)
    }
  };

  useEffect(() => {
    if ((userID !== null | userID !== undefined || userID?.length > 0) && globalData) {

      const host = window.location.host;

      let env = ""
      if (host === "preview.hubzu.com") {
        env = "UAT";
      } else if (host === "hubzu.com" || host === "www.hubzu.com" || host === "mirror.hubzu.com" || host === "www.mirror.hubzu.com") {
        env = "PROD";
      } else {
        env = "INTEG";
      }

      inititaliseFirebase(globalData["firebaseConfig"][env]);


      const db = getDatabase();


      const starCountRef = ref(db, "/" + globalData["firebaseConfig"][env]?.dbPath + '/users/' + userID + '/summary');

      // Wait for Firebase auth before subscribing to user-specific data
      import("firebase/auth").then(({ getAuth: getFirebaseAuth, onAuthStateChanged: onAuthChanged, signInWithCustomToken: signInWithToken }) => {
        const auth = getFirebaseAuth();

        if (auth.currentUser) {
          attachAlertListener();
        } else {
          const unsubAuth = onAuthChanged(auth, (user) => {
            if (user) {
              attachAlertListener();
              unsubAuth();
            }
          });

          // Try to re-authenticate in case the login flow didn't do it
          alertsSummary().then((summary) => {
            const token = summary?.data?.token;
            if (token && !auth.currentUser) {
              signInWithToken(auth, token).catch(() => {});
            }
          }).catch(() => {});
        }
      });

      function attachAlertListener() {
        const unsubscribe = onValue(starCountRef, (snapshot) => {

        const data = snapshot.val();

        // Track Firebase notification received
        trackPageMount({
          pageName: "global_alerts_view",
          eventCategory: "GlobalAlerts view",
          eventSource: "Firebase notifications",
        })

        const unReadMessageCount = snapshot.child('pendingMessages').val() || 0;
        dispatch(setAlertsCount(unReadMessageCount));

        const alertMessage = snapshot.child('lastMessage').val() || '';

        if (unReadMessageCount > 0) {
          // Track when user has unread notifications
          trackPageMount({
            pageName: "global_alerts_notification",
            eventCategory: "GlobalAlerts",
            eventSource: "Firebase notifications",
            eventLabel: { unreadCount: unReadMessageCount }
          })

          const lastMessage = snapshot.child('lastMessage').val() || 0;
          if (lastMessage.length > 0) {
            trackPageMount({
              pageName: "alerts_available",
              eventCategory: "GlobalAlerts",
              eventSource: "Firebase notifications",
              eventLabel: { "alerts count": lastMessage.length }
            })
            setIsLoadingAlerts(true);
            notifyUser(lastMessage);

            getAlertData().then((res) => {
              setIsLoadingAlerts(false);
              dispatch(setAlerts({
                ...res,
                alerts: [...res.alerts] // ensures new reference
              }));
              // dispatch(setAlerts(res));

            });
          }

        }
      }, (error) => {
        // Permission denied - Firebase auth may not be ready
      });
      } // end attachAlertListener
      // onChildAdded(starCountRef, (snapshot) => {
      //   const data = snapshot.val();

      //   console.log('onChildAdded summary -> ', data);


      // });



      // onChildChanged(starCountRef, (snapshot) => {
      //   const data = snapshot.val();

      //   console.log('onChildChanges summary -> ', data);


      // });


      // const messageDb = ref(db, '/buy/users/' + userID + '/messages');

      // onValue(messageDb, (snapshot) => {
      //   const data = snapshot.val();
      //   console.log('messageDb snap -> ', data);
      // }
      // );

      // onChildChanged(messageDb, (snapshot) => {
      //   const data = snapshot.val();

      //   console.log('onChildChanged snap -> ', data);


      // });

      // onChildAdded(starCountRef, (snapshot) => {
      //   const data = snapshot.val();

      //   console.log('onChildAdded message -> ', data);


      // });


      return () => {
        off(starCountRef); // Remove all listeners from this reference
        // unsubscribe(); // Clean up the listener
      };// clean up listener on unmount
    }
  }, [userID]);

  const notifyUser = (message) => {
    toast(message, {
      closeOnClick: true,
      autoClose: 500,
      theme: 'colored',
      style: { background: '#fcf8e3', color: "black", textAlign: 'center' },
    });
  }

  const formattedStateOptions = stateList?.map((state) => ({
    value: state,
    label: state,
  }));
  let curr = new Date();
  curr.setDate(curr.getDate());
  let date = curr.toISOString().substring(0, 10);

  const formDetails = [
    {
      label: "First Name",
      type: "text",
      name: "firstName",
      placeholder: "First Name",
      required: true,
      editLink: false,
    },
    {
      label: "Last Name",
      type: "text",
      name: "lastName",
      placeholder: "Last Name",
      required: true,
      editLink: false,
    },
    {
      label: "Email",
      type: "email",
      name: "emailId",
      placeholder: "Email",
      required: true,
      editLink: true,
    },
    {
      label: "Address Line1",
      name: "addressLine1",
      type: "text",
      placeholder: "Address Line1",
      required: true,
      editLink: false,
    },
    {
      label: "Address Line 2",
      name: "addressLine2",
      type: "text",
      placeholder: "Address Line 2",
      required: false,
      editLink: false,
    },
    {
      label: "State",
      type: "dropdown",
      name: "state",
      placeholder: "State",
      required: true,
      editLink: false,
      options: formattedStateOptions,
      // handleChange: (e) => handleStateChange(e)
    },
    {
      label: "City",
      type: "dropdown",
      name: "city",
      placeholder: "City",
      required: true,
      editLink: false,
      options: cities,
    },
    {
      label: "Zip code",
      type: "number",
      name: "zipCode",
      placeholder: "Zip Code",
      required: true,
      editLink: false,
    },
    {
      label: "Mobile",
      type: "tel",
      name: "phoneNumber",
      placeholder: "Mobile",
      required: true,
      editLink: false,
    },
  ];

  // console.log("profileInfo ->", profileInfo);
  // const onSubmit = async (data) => {
  //   try {
  //     const response = await saveUserDetails(data);
  //     // setIdologyStack(true)
  //     console.log("response ->", response);
  //     if (response.status === "SUCCESS") {
  //       getUserProfile().then((pdata) => {
  //         dispatch(setProfileInfo(pdata))
  //       dispatch(setProfileInfo(pdata))
  //       });

  //       setIsProfileComplete(true);

  //       if (response?.data?.idologyVerificationRequired === true) {
  //         console.log(
  //           "idologyVerificationRequired => ",
  //           response?.data?.idologyVerificationRequired
  //         );
  //         setIsIdologyVerified(false);
  //       } else {
  //         setIsIdologyVerified(true);
  //       }
  //     }
  //     toast.success("User details saved successfully");
  //   } catch (error) {
  //     toast.error("Failed to save user details");
  //     console.error("Save error:", error);
  //   }
  // };

  useEffect(() => {
    if (agentLicenseInfo?.length > 0) {
      setLicenseEmpty(false)
      delete errors["licenseEmpty"];
    } else {
      setLicenseEmpty(true)
    }
  }, [agentLicenseInfo])

  const onSubmit = async (data) => {
    try {
      setIsLoading(true);
      setUserProfileData(null);

      const response = await saveUserDetails(data);

      if (!response) {
        throw new Error("No response received");
      }

      switch (response.status) {
        case "SUCCESS":
          getUserProfile().then((pdata) => {
            dispatch(setProfileInfo(pdata?.data))
          });

          trackApiCall({
            eventName: "profile_update_success",
            eventCategory: "Profile Forms Global Alerts",
            eventLabel: "Global Alerts Drawer"
          })
          trackApiCall({
            eventName: "idology_request_success",
            eventCategory: "globalAlertsIdology",
            eventLabel: "Global Alerts Drawer"
          })

          setIsProfileComplete(true);

          if (response?.data?.idologyVerificationRequired === true) {
            setIsIdologyVerified(false);
            trackApiCall({
              eventName: "idology_verify_click",
              eventCategory: "globalAlertsIdology",
              eventLabel: "Global Alerts Drawer"
            })
          } else {
            setIsIdologyVerified(true);
          }
          break;

        case "FAILURE":
          const errorMessage =
            response.errorMessage === "INVALID_MANDATORY_PARAMETER_VALUE"
              ? "Invalid Mandatory Parameter Value"
              : response.errorMessage === "REGISTRATION_ZIP_FAILURE"
                ? "Provided zip code is not valid for the state"
                : "Something went wrong";
          if (response.errorMessage === "REGISTRATION_ZIP_FAILURE" || response.errorMessage === "VALIDATION_STATE_ZIP_FAILURE") {
            setErrors({
              ...errors,
              zipCode: "Provided zip code is not valid for the state",
            });
          }
          // toast.error(errorMessage);
          break;

        // default:
        //   toast.error("Unexpected response status");
      }
    } catch (error) {
      toast.error(error || "Failed to save user details");
      console.error("Save error:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const licenseFields = [
    {
      label: "Issued By",
      type: "text",
      name: "affiliatedCompany",
      required: true,
      placeholder: "Enter Company Name",
    },
    {
      label: "License Number",
      type: "text",
      name: "licenseNumber",
      required: true,
      placeholder: "Enter License Number",
    },
    {
      label: "State",
      type: "select",
      name: "stateId",
      required: true,
      options: stateList?.map((state) => ({
        value: state,
        label: state,
      })),
    },
    {
      label: "Expiry Date",
      type: "date",
      name: "licenseExpiryDate",
      required: true,
      placeholder: "MM/DD/YYYY",
    },
    {
      label: "License State Office Address",
      type: "header", // This will be rendered as a subheading
      name: "addressHeader",
    },
    {
      label: "Address Line 1",
      type: "text",
      name: "agentLicenseAddress1",
      required: false,
      placeholder: "Enter Address Line 1",
    },
    {
      label: "Address Line 2",
      type: "text",
      name: "agentLicenseAddress2",
      required: false,
      placeholder: "Enter Address Line 2",
    },
    {
      label: "State",
      type: "select",
      name: "agentLicenseState",
      required: false,
      options: stateList?.map((state) => ({
        value: state,
        label: state,
      })),
    },
    {
      label: "City",
      type: "select",
      name: "agentLicenseCity",
      required: false,
      placeholder: "Enter City",
      options: cities,
    },
    {
      label: "Zip Code",
      type: "text",
      name: "agentLicenseZip",
      required: false,
      placeholder: "Enter Zip Code",
      pattern: "[0-9]{5}",
      maxLength: 5,
    },
  ];

  const formatDate = (dateString) => {
    if (dateString?.includes("-")) {
      const [year, month, day] = dateString.split("-");
      return `${month}/${day}/${year}`;
    } else if (dateString?.includes("/")) {
      const [month, day, year] = dateString.split("/");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    }
    return dateString;
  };

  const IdologyFormValues = {
    userBasicDetails: {
      firstName: formData?.firstName,
      lastName: formData?.lastName,
      emailId: formData?.emailId,
    },
    dob: formatDate(dob), // Use React state for DOB
    ssn: ssn, // Use React state for SSN
  };

  const verifyLoginStatus = async () => {
    try {
      const response = await checkLoginStatus();
      setIsUserLogggedInLocal(response?.screenName?.length > 0 ? true : false);
      setUserType(response?.userType);
    } catch (error) { }
  };

  useEffect(() => {
    setShowIdolodyQuestions(false)
    setIdeologyError("")
    if (userData.alertsRegister) {
      // if(!initialFetchDone.current){

      getUserProfile().then((pdata) => {
        dispatch(setProfileInfo(pdata?.data))
        setShowLicenseTable(pdata?.data?.role === "AGENT");
        setAgentLicenseInfo(pdata?.data?.agentLicenseInfo);
        console.log("license ->", pdata?.data?.agentLicenseInfo);

        setAgentCorpLicenseInfo(pdata?.data?.agentCorpLicenseInfo);
        verifyLoginStatus();

        setUserDataLocal(pdata?.data?.userDetails);
        // setUserType(pdata?.data?.userDetails?.userRoles);
        const profileData = profileInfo?.userDetails;
        // dispatch(setUserDetailsSlices(userProfile?.data));
        // setUserRoles(profileInfo?.userDetails?.userRoles || []);

        setFormData({
          ...formData,
          firstName: profileData?.firstName || "",
          lastName: profileData?.lastName || "",
          emailId: profileData?.emailId || "",
          addressLine1: profileData?.address?.address1 || "",
          addressLine2: profileData?.address?.address2 || "",
          state: profileData?.address?.state || "",
          city: profileData?.address?.city || "",
          zipCode: profileData?.address?.zip || "",
          phoneNumber: profileData?.phoneNumber || "",
          userRoles: profileData?.userRoles || [],
          address: {
            address1: profileData?.address?.address1 || "",
            address2: profileData?.address?.address2 || "",
            city: profileData?.city || "",
            cityFromDropDown: false,
            state: profileData?.address?.city,
            zip: profileData?.address?.zip,
          },
        });

        // If the user has a state, fetch its cities
        if (profileData?.address?.state) {
          const citiesData = getCitiesByState(profileData?.address?.state);
          const cityArray = citiesData.data || citiesData;
          setCities(Array.isArray(cityArray) ? cityArray : []);
        }

        if (
          profileData?.address?.address1 === null ||
          profileData?.address?.address1?.length === 0 ||
          profileData?.address?.city === null ||
          profileInfo?.userDetails?.address?.city?.length === 0
        ) {
          setIsProfileComplete(false);
          // renderProfileCompletionAlert();
        } else {
          isIdologyVerificationRequired().then((idologyReq) => {
            if (idologyReq?.data === true) {
              setIsIdologyVerified(false);
              // renderIdeolodyScreen();
            } else {
              getAlertData().then((res) => {
                dispatch(setAlerts({
                  ...res,
                  alerts: [...res.alerts] // ensures new reference
                }));
              });
            }
          });
        }
      });
      // initialFetchDone.current = true;
      //}
    }
  }, [userData.alertsRegister]);

  useEffect(() => {
    // if(!initialFetchDone.current){
    setShowIdolodyQuestions(false)
    setIdeologyError("")
    setErrors({})
    setDob("")
    setSsn("")
    setShowLicenseTable(profileInfo?.role === "AGENT");
    setAgentLicenseInfo(profileInfo?.agentLicenseInfo !== undefined ? profileInfo?.agentLicenseInfo : []);

    setAgentCorpLicenseInfo(profileInfo?.agentCorpLicenseInfo !== undefined ? profileInfo?.agentCorpLicenseInfo : []);
    verifyLoginStatus();

    setUserDataLocal(profileInfo?.userDetails);
    // setUserType(pdata?.data?.userDetails?.userRoles);
    const profileData = profileInfo?.userDetails;
    // dispatch(setUserDetailsSlices(userProfile?.data));
    // setUserRoles(profileInfo?.userDetails?.userRoles || []);
    getLicenseAddressRequiredStateList();
    setFormData({
      ...formData,
      firstName: profileData?.firstName || "",
      lastName: profileData?.lastName || "",
      emailId: profileData?.emailId || "",
      addressLine1: profileData?.address?.address1 || "",
      addressLine2: profileData?.address?.address2 || "",
      state: profileData?.address?.state || "",
      city: profileData?.address?.city || "",
      zipCode: profileData?.address?.zip || "",
      phoneNumber: profileData?.phoneNumber || "",
      userRoles: profileData?.userRoles || [],
      address: {
        address1: profileData?.address?.address1 || "",
        address2: profileData?.address?.address2 || "",
        city: profileData?.city || "",
        cityFromDropDown: false,
        state: profileData?.address?.city,
        zip: profileData?.address?.zip,
      },
    });

    // If the user has a state, fetch its cities
    if (profileData?.address?.state) {
      const citiesData = getCitiesByState(profileData?.address?.state);
      const cityArray = citiesData.data || citiesData;
      setCities(Array.isArray(cityArray) ? cityArray : []);
    }

    if (
      profileData?.address?.address1 === null ||
      profileData?.address?.address1?.length === 0 ||
      profileData?.address?.city === null ||
      profileInfo?.userDetails?.address?.city?.length === 0
    ) {
      setIsProfileComplete(false);
      // renderProfileCompletionAlert();
    } else {
      // isIdologyVerificationRequired().then((idologyReq) => {
      //     if (idologyReq?.data === true) {
      //         setIsIdologyVerified(false)
      //         // renderIdeolodyScreen();
      //     } else {
      //         getAlertData().then((res) => {
      //             dispatch(setAlerts(res))
      //             // setAlertsData(res.alerts);
      //         });
      //     }
      // });
    }
  }, [profileInfo]);

  const getConfirmationMessage = () => {
    const currentRole = formData.role || formData.userRoles?.[0] || "BUYR";

    if (currentRole === "agent" && pendingRoleChange === "BUYR") {
      return "Are you sure you want to switch your role? All your licenses will be deleted. Please confirm.";
    }
    return "Are you sure you want to switch roles?";
  };

  const handleEditClick = async (rowData) => {

    console.log('rowData ->', rowData);
    setLicenseType("Indv");
    await getLicenseDetails(rowData.licenseId);
    setInitialValues({
      licenseNumber: rowData.licenseNumber,
      stateId: rowData?.stateId,
      agentLicenseAddress1: rowData.address1,
      agentLicenseAddress2: rowData.address2,
      agentLicenseCity: rowData.city,
      agentLicenseZip: rowData.zip,
      affiliatedCompany: rowData.afftCompanyName || rowData?.company,
      agentLicenseState: rowData.agentLicenseState,
      licenseExpiryDate: rowData.expiryDate
        ? formatDisplayDate(parseDateString(rowData.expiryDate))
        : "",
      cityFromDropDown: rowData.cityFromDropDown || false,
      licenceId: rowData.licenseId,
    });
    setModalMode("edit");
    setShowModal(true);
    setLicenseLoading(false);
  };

  const handleEditCorpClick = async (rowData, type) => {
    setLicenseType("Corp");
    const data = await editCorporateDetail(rowData.licenseId);
    setInitialCorpValues({
      licenseNumber: data?.data?.data?.licenseNumber,
      stateId: data?.data?.data?.stateId,
      agentLicenseAddress1: data?.data?.data?.address1,
      agentLicenseAddress2: data?.data?.data?.address2,
      agentLicenseCity: data?.data?.data?.city,
      agentLicenseZip: data?.data?.data?.zip,
      affiliatedCompany: data?.data?.data?.company,
      agentLicenseState: data?.data?.data?.state,
      licenseExpiryDate: data?.data?.data?.expiryDate
        ? formatDisplayDate(parseDateString(data?.data?.data?.expiryDate))
        : "",
      cityFromDropDown: rowData?.cityFromDropDown || false,
      licenceId: rowData?.licenseId,
    });
    setModalMode("edit");
    setShowModal(true);
  };

  const verifyUserWithDetails = async () => {

    if (errors.dob) {
      setIdeologyError("");
      return null
    }
    const formValues = {
      firstName: formData.firstName,
      lastName: formData.lastName,
      dob: dob,
      ssn: ssn,
    };

    const validationErrors = validateForm(formValues, Object.keys(formValues), true);
    setIdeologyFormErrors(validationErrors);

    if (Object.keys(validationErrors).length > 0) {
      return;
    }


    trackButtonClick({
      eventName: "idology_submit",
      eventCategory: "globalAlertsIdology",
      eventSource: "Global alerts idology from alerts"
    })

    try {
      const verificationResult = await verifyUserProfile(IdologyFormValues);
      if (verificationResult?.status === "SUCCESS") {
        if (verificationResult?.data?.questions?.length > 0) {
          setQuestions(verificationResult?.data?.questions)
          setShowIdolodyQuestions(true)
        } else {
          trackApiCall({
            eventName: "idology_verification_success",
            eventCategory: "globalAlertsIdology",
            eventSource: "Global alerts idology from alerts",
            eventParams: { idology_verification: "successful" }
          })
             if(profileInfo?.userDetails?.phoneNumberVerified === true){
              trackEvent({
                name: "ready_to_bid",
                category: "New-Bid Wizard",
                eventSource: "on Ideology Verification",
                eventLabel: "",
              });

            }
          toast.success("Your profile is verified successfully.");
          setIdeologyError("");
          setIsIdologyVerified(true);
          getAlertData().then((res) => {
            dispatch(setAlerts({
              ...res,
              alerts: [...res.alerts] // ensures new reference
            }));
            // setAlertsData(res.alerts);
          });
        }
      } else {
        trackApiCall({
          eventName: "confirm_idology_failure",
          eventCategory: "globalAlertsIdology",
          eventSource: "Global alerts idology from alerts",
          eventParams: {
            error_type:
              verificationResult?.errorMessage === "errorIdologyAttemptsExceeded"
                ? "attempt_exceeded"
                : verificationResult?.errorMessage === "errorIdologyIdFailure" &&
                  verificationResult?.data?.remainingAttemptCount === 0
                ? "attempt_exceeded"
                : verificationResult?.errorMessage === "errorIdologyDuplicate"
                ? "idology_duplicate"
                : "idology_failure",
          },
        });
        setIdeologyError(verificationResult?.errorMessage);
        setRemainingCount(verificationResult.data?.remainingAttemptCount);
        setRemainingAttemptCount(verificationResult.data?.remainingAttemptCount)
        const showLink = verificationResult?.data?.resetCountExceeded && verificationResult?.data?.scanAvailable && !verificationResult?.data?.mailSent
        setShowSendLink(showLink);
        if (verificationResult?.errorMessage === "errorIdologyDuplicate") {
          setMaskedDuplicateEmailID(verificationResult?.data?.maskedDuplicateEmailID)
        }
        // toast.error("User profile verification failed. Please try again.");
      }
    } catch (error) {
      // toast.error("An error occurred while verifying the user profile.");
      console.error("Error fetching user profile verification details:", error);
    }
  };

  //submit (add/update license)
  const handleLicenseFormSubmit = async (licenseData) => {
    try {
      if (modalMode == "Add") {
        setLicenseLoading(true);
        setInitialValues(null);
        const data = await verifyLicenseDetails(
          licenseData?.licenceNumber,
          licenseData?.stateId
        );
        if (data?.data?.verificationStatus === "LICENSE_FORMAT_NOT_OK") {
          let agentStateError =
            AgentLiecenseErrorMsgs[data?.data?.jurisdictName];
          if (agentStateError !== "No license format information") {
            setErrorSubmitting(agentStateError);
            setShowModal(true);
          }
          setLicenseLoading(false);
        } else {
          setErrorSubmitting("");
          const response = await insertUserLicense(licenseData);
          if (response?.status === "SUCCESS" && (response?.license_status === "LCNS_APRD" || response?.license_status === "LCNS_PEND")) {
            setShowModal(false);

            const allLicense = await getAllLicenseDetails();
            setAgentLicenseInfo(allLicense?.response?.INDV || []);

            if (response?.license_status === "LCNS_APRD") {
              toast.success("License Added successfully", {
                closeOnClick: true,
                autoClose: 5000,
              });
            } else {
              toast.error("License update pending. Please check data in Arello.", {
                closeOnClick: true,
                autoClose: 5000,
              });
            }
            setLicenseLoading(false);
            setLicenseEmpty(false);

            trackApiCall({
              eventName: "add_license_click_success",
              eventCategory: "Profile Forms Global Alerts",
              eventLabel: "Agent",
            });
          } else if (response?.status === "SUCCESS") {
            const statusMessages = {
             // "LCNS_PEND": "License update pending. Please check data in Arello.",
              "LCNS_RJCT": "License update pending. Please check data in Arello.",
              "LCNS_SUSP": "License update pending. Please contact Hubzu customer care."
            };
            toast.error(statusMessages[response?.license_status] || "License processing failed");
            setShowModal(false);
            setLicenseLoading(false);
          } else {
            if (response?.ERROR === "VALIDATION_STATE_ZIP_FAILURE") {
              trackApiCall({
                eventName: "add_license_click_failure",
                eventCategory: `Error - License add Global Alerts - VALIDATION_STATE_ZIP_FAILURE`,
                eventSource: "on add license failure",
                eventLabel: "Agent",
              });
              setErrorSubmitting(
                "Provided zip code is not valid for selected state"
              );
            } else {
              toast.error(response?.ERROR);
              setShowModal(false);
            }
          }
        }
      } else {
        setInitialValues(null);
        setLicenseLoading(true);
        const data = await verifyLicenseDetails(
          licenseData?.licenceNumber,
          licenseData?.stateId
        );
        if (data?.data?.verificationStatus === "LICENSE_FORMAT_NOT_OK") {
          let agentStateError =
            AgentLiecenseErrorMsgs[data?.data?.jurisdictName];
          if (agentStateError !== "No license format information") {
            setErrorSubmitting(agentStateError);
            setShowModal(true);
          }
          setLicenseLoading(false);
        } else {
          setErrorSubmitting("");
          const response = await updateUserLicense(licenseData);
          if (response?.status === "SUCCESS" && response?.license_status === "LCNS_APRD") {
            trackApiCall({
              eventName: "update_license_click_success",
              eventCategory: "Profile Forms Global Alerts",
              eventLabel: "Agent",
            });
            const allLicense = await getAllLicenseDetails();
            setAgentLicenseInfo(allLicense?.response?.INDV || []);
            toast.success("License Added successfully", {
              closeOnClick: true,
              autoClose: 5000,
            });
            setLicenseLoading(false);
            setShowModal(false);
          } else if (response?.status === "SUCCESS") {
            const statusMessages = {
              "LCNS_PEND": "License update pending. Please check data in Arello.",
              "LCNS_RJCT": "License update pending. Please check data in Arello.",
              "LCNS_SUSP": "License update pending. Please contact Hubzu customer care."
            };
            toast.error(statusMessages[response?.license_status] || "License processing failed");
            setLicenseLoading(false);
            setShowModal(false);
          } else {
            if (response?.ERROR === "VALIDATION_STATE_ZIP_FAILURE") {
              trackApiCall({
                eventName: "update_license_click_failure",
                eventCategory: `Error - License update Global Alerts - VALIDATION_STATE_ZIP_FAILURE`,
                eventSource: "on update license failure",
                eventLabel: "Agent",
              });
              setErrorSubmitting(
                "Provided zip code is not valid for selected state"
              );
            } else {
              toast.error(response?.ERROR);
              setShowModal(false);
            }
          }
        }
      }
    } catch (error) {
      toast.error("Failed to update license");
      throw error; // This will be caught by the modal's error handling
    } finally {
      setLicenseLoading(false);
    }
  };

  const fetchAgentLicenses = async () => {
    try {
      const response = await getAgentLicenses(); // Your API call
      setAgentLicenseInfo(response.data);
    } catch (error) {
      console.error("Error fetching licenses:", error);
      toast.error("Failed to fetch licenses");
    }
  };

  const openAddLicenseModal = (type) => {
    if (type === "Corp") {
      setLicenseType("Corp");
      setErrorSubmitting("")
      setInitialCorpValues({
        licenseNumber: "",
        stateId: "",
        agentLicenseAddress1: "",
        agentLicenseAddress2: "",
        agentLicenseCity: "",
        agentLicenseZip: "",
        affiliatedCompany: "",
        agentLicenseState: "",
        licenseExpiryDate: "",
        cityFromDropDown: "",
        primaryAgentLicenceId: "",
      });
    } else {
      setLicenseType("Indv");
      setErrorSubmitting("")
      setInitialValues({
        licenseNumber: "",
        stateId: "",
        agentLicenseAddress1: "",
        agentLicenseAddress2: "",
        agentLicenseCity: "",
        agentLicenseZip: "",
        affiliatedCompany: "",
        agentLicenseState: "",
        licenseExpiryDate: "",
        cityFromDropDown: "",
        primaryAgentLicenceId: "",
      });
    }
    setShowModal(true);
    setModalMode("Add");
  };

  const handleSmSOptChange = async (event) => {
    const selectedValue = event.target.value;
    console.log('selectedValu->', selectedValue);
    setSMSOptInStatus(selectedValue);
  };

  const handleValidation = () => {

  }

  // const handleUserFormSubmit = async (event) => {
  //   event.preventDefault();

  //  isValidData = handleValidation();
  //  if(isValidData){
  //   try {
  //     setUserSubmitForm(true);

  //     // Create payload in exact format needed
  //     const payload = {
  //       address: {
  //         address1: formData.addressLine1 || "",
  //         address2: formData.addressLine2 || "",
  //         city: formData.city || "",
  //         cityFromDropDown: false,
  //         state: formData.state || "",
  //         zip: formData.zipCode || "",
  //       },
  //       companyName: "",
  //       emailId: formData.emailId || "",
  //       firstName: formData.firstName || "",
  //       lastName: formData.lastName || "",
  //       phoneNumber: formData.phoneNumber || "",
  //       smsOptInStatus: smsOptInStatus,
  //       userId: formData.userId || "",
  //       role: formData.role || userType,
  //       userRoles: formData.userRoles || [],
  //     };

  //     console.log("Submitting payload:", payload); // For debugging

  //     onSubmit(payload);
  //   } finally {
  //     setUserSubmitForm(false);
  //   }
  //  }else{

  //  }
  // };

  const handleUserFormSubmit = async (event) => {
    event.preventDefault();
    setErrors({})
    const newErrors = {};

    // ✅ Validate only fields from formDetails, skip radio
    formDetails.forEach((field) => {
      const value = formData[field.name];
      if (field.required && (!value || value.trim() === "")) {
        if (field.name === "addressLine1") {
          newErrors[field.name] = `Please enter a valid address.`;
        } else {
          newErrors[field.name] = `This field is required.`;
        }
      }
    });

    if (licenseEmpty && userType === "AGENT") {
      newErrors["licenseEmpty"] = "Please enter valid license details";
    }

    if (
      Object.keys(newErrors).length > 0

    ) {

      setErrors(newErrors);
      return;
    }


    // handle validation for subscription option if user has not subscribed
    if (smsOptInStatus === null) {
      newErrors["smsOptInStatus"] = "Please select one option";
    }



    try {
      setIsLoading(true);
      setUserSubmitForm(true);
      if (userType === "BUYR") {

        const payload = {
          address: {
            address1: formData.addressLine1 || "",
            address2: formData.addressLine2 || "",
            city: formData.city || "",
            cityFromDropDown: false,
            state: formData.state || "",
            zip: formData.zipCode || "",
          },
          companyName: "",
          emailId: formData.emailId || "",
          firstName: formData.firstName || "",
          lastName: formData.lastName || "",
          phoneNumber: formData.phoneNumber || "",
          smsOptInStatus: smsOptInStatus,
          userId: formData.userId || "",
          role: formData.role || userType,
          userRoles: formData.userRoles || [],
        };



        const redisPayload = new FormData();
        redisPayload.append("emailId", formData?.emailId);

        const isPhoneinUse = await isPhoneNoInUse(formData?.phoneNumber);

        if (isPhoneinUse?.data?.data === false) {

          // const isBuyerProfileSaved = await saveBuyerProfile(payload);
          // console.log("isBuyerProfileSaved ->", isBuyerProfileSaved);

          // if (isBuyerProfileSaved?.status === "SUCCESS") {
          //   toast.success("Profile completed");

          //   await checkDeletedUserEmail(redisPayload);
          //   const userProfile = await getUserProfile();

          //   if (!userProfile?.data?.userDetails) {
          //     throw new Error("User profile data not found");
          //   }
          //   setUserProfileData(userProfile.data.userDetails);
          // } else {
          //   toast.error("Failed to save user details");
          // }
          onSubmit(payload);
        } else {
          newErrors['phoneNumber'] = `Phone number already in use`;
        }
      } else {
        const agentPayload = {
          address: {
            address1: formData.addressLine1 || "",
            address2: formData.addressLine2 || "",
            city: formData.city || "",
            cityFromDropDown: false,
            state: formData.state || "",
            zip: formData.zipCode || "",
          },
          companyName: "",
          emailId: formData.emailId || "",
          firstName: formData.firstName || "",
          lastName: formData.lastName || "",
          phoneNumber: formData.phoneNumber || "",
          smsOptInStatus:
            smsOptInStatus === "Yes"
              ? "Y"
              : smsOptInStatus === "No"
                ? "N"
                : profileInfo?.userDetails?.smsOptInStatus,
          userId: formData.userId || "",
          userRoles: [formData.role || "AGENT"],
        };
        onSubmit(agentPayload);
      }
    } catch (e) {

      console.error("Failed to save user details");
    } finally {
      setUserSubmitForm(false);
      setIsLoading(false);
    }
  };

  // console.log('smsOptInStatus ->', smsOptInStatus);
  const handleRoleChange = (e) => {
    const newRole = e.target.value;

    if (e.target.value === "AGENT") {
      setShowConfirmation(true);
    } else {
      setFormData((prev) => ({
        ...prev,
        role: newRole,
      }));
      setShowLicenseTable(newRole === "AGENT");
      setUserType(newRole);
    }
    // Show license table only if AGENT is selected
  };

  const handleDeleteLicense = async (licenseId) => {

    console.log('licenseId ->', licenseId)
    try {
      await deleteLicense(licenseId);
      toast.success("License deleted successfully", { autoClose: 5000 });
      const allLicense = await getAllLicenseDetails();
      setAgentLicenseInfo(allLicense?.response?.INDV || []);
    } catch (error) {
      console.error("Error deleting license:", error);
      // toast.error("Failed to delete license");
    } finally {
      setIsLoading(false);
    }
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    // Handle form submission
    handleClose();
  };

  const handleVerify = () => { };

  const handleCityChange = async (e) => {
    const city = e.target.value;

    const validationErrors = validateForm({ ['city']: city }, ['city']);

    setErrors((prevErrors) => ({
      ...prevErrors,
      ['city']: validationErrors['city'] || "",
    }));

    setFormData((prev) => ({
      ...prev,
      city: city, // Reset city when state changes
    }));


  };

  const handleStateChange = async (e) => {
    const stateCode = e.target.value;

    const validationErrors = validateForm({ ['state']: stateCode }, ['state']);

    setErrors((prevErrors) => ({
      ...prevErrors,
      ['state']: validationErrors['state'] || "",
    }));

    setFormData((prev) => ({
      ...prev,
      state: stateCode,
      city: "", // Reset city when state changes
    }));

    if (stateCode) {
      try {
        // const response = await getCitiesByState(stateCode);

        const citiesData = await getCitiesByState(stateCode);
        const cityArray = citiesData.data || citiesData;
        setCities(Array.isArray(cityArray) ? cityArray : []);

      } catch (error) {
        console.error("Error fetching cities:", error);
        setCities([]);
      }
    } else {
      setCities([]);
    }


  };

  const handleDeleteCorpLicense = async (licenseId) => {
    try {
      await deleteCorporateLicence(licenseId);
      toast.success("License deleted successfully", { autoClose: 5000, });
      const allLicense = await getAllLicenseDetails();
      setAgentCorpLicenseInfo(allLicense?.response?.CORP || []);
    } catch (error) {
      console.error("Failed to delete license")
      // toast.error("Failed to delete license");
    } finally {
      setIsLoading(false);
    }
  };

  const shouldShowProfile = () => {
    if (profileInfo === null ||
      profileInfo?.userDetails?.address?.address1 === null ||
      profileInfo?.userDetails?.address?.address1?.length === 0 ||
      profileInfo?.userDetails?.address?.city === null ||
      profileInfo?.userDetails?.address?.city?.length === 0
    ) {
      return true;
    } else {

      return false;
    }
  };

  const idologySuccess = () => {
    setIdeologyError("");
    setIsIdologyVerified(true);
    getAlertData().then((res) => {
      dispatch(setAlerts(res));
    });
  };

  const handleInputChange = (event, setFormData, setErrors, validateForm) => {
    const { id, value } = event.target;

    console.log('id ->', id);

    // Update the form data state
    setFormData((prevData) => ({
      ...prevData,
      [id]: value,
    }));

    // Perform validation using validateForm utility
    const validationErrors = validateForm({ [id]: value }, [id]);

    // Update errors state dynamically
    setErrors((prevErrors) => ({
      ...prevErrors,
      [id]: validationErrors[id] || "", // Add error if invalid, or clear if valid
    }));
  };

  const handleDobChange = (e) => {
    const { name, value } = e.target;
    setDob(value)
    const validationErrors = validateForm({ [name]: value }, [name]);
    setIdeologyFormErrors((prevErrors) => ({
      ...prevErrors,
      [name]: validationErrors[name] || "",
    }));
  }

  const handleCloseIdolodyQuestions = () => {
    setShowIdolodyQuestions(false);
    setDob("");
    setSsn("")
  }

  useEffect(() => {
    setEmailSend(false)
    const fetchUserAttempts = async () => {
      try {
        const response = await getUserProfileVerificationDetails();
        setRemainingAttemptCount(
          response?.data?.userIdologyDetailsDto?.remainingAttemptCount
        );
        setRemainingCount(response?.data?.userIdologyDetailsDto?.remainingAttemptCount)
        const showLink = response?.data?.userIdologyDetailsDto?.resetCountExceeded && response?.data?.userIdologyDetailsDto?.scanAvailable && !response?.data?.userIdologyDetailsDto?.mailSent
        setShowSendLink(showLink)
      } catch (error) {
        console.error("Error fetching remaining attempt count:", error);
      }
    };

    fetchUserAttempts();
  }, []);

  const sendLinkToEmail = async () => {
    try {
      const data = await sendEmailLink();
      if (data?.status === "SUCCESS") {
        setEmailSend(true)
      } else {
        setEmailSend(false);
        console.log(data, 'data error');

      }
    } catch (error) {
      console.log(error);
      setEmailSend(false)
    }
  }
  const handleSsnChange = (e) => {
    const { id, value } = e.target;
    setSsn(value);

    const validationErrors = validateForm({ [id]: value }, [id]);
    setIdeologyFormErrors((prevErrors) => ({
      ...prevErrors,
      [id]: validationErrors[id] || "",
    }));
  };
  const handleIdeologyFieldBlur = (e) => {

    const { id, value } = e.target;
    const validationErrors = validateForm({ [id]: value }, [id]);
    setIdeologyFormErrors((prevErrors) => ({
      ...prevErrors,
      [id]: validationErrors[id] || "",
    }));
  };

  const renderIdeolodyScreen = () => {
    return (
      <div className="">
        <div className="">
          {!showIdolodyQuestions ? (
            <Container className="mt-12">
              <div className="form-group">
                <div className="profile-progress-bar">
                  <div>
                    <span className="fa fa-check fa-xs profile-success-symbol">
                      &nbsp;
                    </span>
                  </div>
                  <div className="stage-success"></div>
                  <div>
                    <span className="fa fa-check fa-xs profile-success-symbol">
                      &nbsp;
                    </span>
                  </div>
                  <div className="stage-inprogress"></div>
                  <div>
                    <span className="glyphicon profile-progress-symbol">
                      &nbsp;
                    </span>
                  </div>
                </div>
                <div className="profile-progress-titles">
                  <div className="globalAlertsTxt">Registration</div>
                  <div className="globalAlertsTxt">Profile Completion</div>
                  <div className="globalAlertsTxt">Idology Verification</div>
                </div>
              </div>
              <br></br>

              <>
                {ideologyError === "errorIdologyAttemptsExceeded" ||
                  remainingAttemptCount === 0 ? (
                  <div className="pb20">
                    {
                      emailSend ? <>
                        We've sent a message to your registered email address. Please follow the instructions to complete your verification by uploading a valid government issued ID.
                      </> : <>

                        <p className=" fs-12">
                          Your account has been locked because you have failed the
                          authentication process three times. Please contact
                          Customer Care at (855) 882-1314 or customercare@hubzu.com
                          for further assistance.
                          {
                            showSendLink && <><br />
                              Alternatively, Hubzu may be able to manually verify your identity using your government-issued identification. Please click below to receive additional information and instructions about this process.

                            </>
                          }
                        </p>
                        {
                          showSendLink && <p className="text-center">
                            <button className="send-link btn btn-primary" onClick={sendLinkToEmail}>Scan Link </button>
                          </p>
                        }
                      </>
                    }
                  </div>
                ) : (
                  <>
                    <Col>
                      <h4 className="profileInfoHeading">
                        Idology Verification
                      </h4>
                    </Col>
                    <div className="alert-warning">
                      <p className="globalAlertsIdologyDescription p15">
                        We require the last four digits of your Social Security
                        number as an additional verification step to protect our
                        customers against potential fraud. The information is
                        used to verify your identity. We do not store your
                        Social Security number or date of birth in our database,
                        and this information is deleted as soon as your identity
                        is verified.
                      </p>
                    </div>
                    <br></br>

                    <div className="idology-form-group">
                      <input
                        type="text"
                        id="firstName"
                        required
                        value={formData.firstName || ""}
                        onChange={(event) =>
                          handleInputChange(
                            event,
                            setFormData,
                            setErrors,
                            validateForm
                          )
                        }
                        onBlur={handleIdeologyFieldBlur}

                        className={`form-control ${ideologyFormErrors.firstName ? "is-invalid" : ""
                          }`} // Add dynamic error class
                      />
                      <label htmlFor="firstName">First Name</label>
                      {ideologyFormErrors.firstName && (
                        <span className="error-message mt-3">
                          {ideologyFormErrors.firstName}
                        </span>
                      )}
                    </div>

                    <div className="idology-form-group">
                      <input
                        type="text"
                        id="lastName"
                        required
                        value={formData.lastName || ""}
                        onChange={(event) =>
                          handleInputChange(
                            event,
                            setFormData,
                            setErrors,
                            validateForm
                          )
                        }
                        onBlur={handleIdeologyFieldBlur}
                        className={`form-control ${ideologyFormErrors.lastName ? "is-invalid" : ""
                          }`} // Add dynamic error class
                      />
                      <label htmlFor="lastName">Last Name</label>
                      {ideologyFormErrors.lastName && (
                        <span className="error-message mt-3">{ideologyFormErrors.lastName}</span>
                      )}
                    </div>

                    <div className="idology-form-group">
                      <input
                        type="date"
                        id="dateOfBirth"
                        required
                        value={dob || ""}
                        name="dob"
                        max={date}
                        onChange={(e) => handleDobChange(e)}
                        onBlur={handleIdeologyFieldBlur}
                        className={`form-control ${ideologyFormErrors.dob ? "is-invalid" : ""
                          }`} // Add dynamic error class
                      />
                      <label htmlFor="dateOfBirth">Date of Birth</label>
                      {ideologyFormErrors.dob && (
                        <span className="error-message mt-3">{ideologyFormErrors.dob}</span>
                      )}
                    </div>

                    <div className="idology-form-group">
                      <div>
                        <input
                          type="text"
                          id="ssn"
                          required
                          value={ssn || ""}
                          onChange={handleSsnChange}
                          onBlur={handleIdeologyFieldBlur}
                          maxLength={4}
                          className={`form-control ${ideologyFormErrors.ssn ? "is-invalid" : ""
                            }`} // Add dynamic error class
                        />
                        <label htmlFor="ssn">Enter Last Four digit of SSN</label>
                      </div>
                      {ideologyFormErrors.ssn && (
                        <span className="error-message mt-3">{ideologyFormErrors.ssn}</span>
                      )}
                    </div>

                    {(ideologyError === "errorIdologyIdFailure" && remainingCount > 0) && (
                      <div className="pb20">
                        <h6 className="error-message text-center fs-11">
                          Authentication failed.
                        </h6>
                        <p className="error-message fs-11">
                          Please enter your first name, last name, last 4 digits
                          of your Social Security Number and date of birth as
                          they appear on government-issued documents.
                        </p>
                        <p className="error-message fs-11">
                          You have {remainingCount} more attempt to log in
                          before your account is locked. Please call Customer
                          Care at (855) 882-1314 with questions or concerns.
                        </p>
                      </div>
                    )}
                    {ideologyError === "errorIdologyAttemptsExceeded" && (
                      <div className="pb20">
                        <p className="error-message fs-11">
                          Your account has been locked because you have failed
                          the authentication process three times. Please contact
                          Customer Care at (855) 882-1314 or
                          customercare@hubzu.com for further assistance.
                        </p>
                      </div>
                    )}
                    {ideologyError === "errorIdologyDuplicate" && (
                      <div className="pb20">
                        <h6 className="error-message text-center fs-11">
                          Authentication failed.
                        </h6>
                        <p className="error-message fs-11">
                          Our records show, you already have an account on Hubzu
                          with {maskedDuplicateEmailID}. If you want to change
                          the email id, please login to Hubzu.com and change the
                          email Id. Please contact customer care at (855)
                          882-1314 or customercare@hubzu.com for any assistance.
                        </p>
                      </div>
                    )}
                    {ideologyError === "errorIdologySystemError" && (
                      <div className="pb20">
                        <p className="error-message fs-11">
                          We’re currently experiencing technical difficulties
                          with the verification system. Please try again later
                          or contact Customer Care at (855) 882-1314.
                        </p>
                      </div>
                    )}

                    <Button
                      variant="submit"
                      id="alerts-verify-idology-btn"
                      className="btn btn-primary  px-4 shadow-sm"
                      style={{
                        width: "100%",
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                      }}
                      onClick={verifyUserWithDetails}
                      disabled={isLoading}
                    >
                      {isLoading ? "verifying" : "Verify"}
                    </Button>
                    <br></br>
                  </>
                )}
              </>
            </Container>
          ) : (
            <IdologyQuestions
              dob={formatDate(dob)}
              ssn={ssn}
              questions={question}
              setQuestions={setQuestions}
              handleClose={() => handleCloseIdolodyQuestions()}
              isFromAlerts={true}
              idoSuccess={idologySuccess}
              setIdeologyError={setIdeologyError}
              parentComponent="GlobalAlerts"
            />
          )}
        </div>
      </div>
    );
  };

  const handleBlur = (e, item) => {

    const value = e.target.value;
    const name = item?.name;


    const validationErrors = validateForm({ [name]: value }, [name]);

    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: validationErrors[name] || "",
    }));
    if (name === "addressLine2" && value.length === 0) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        [name]: "",
      }));
    }

  };

  const handleChangeAgent = async () => {
    setFormData((prev) => ({
      ...prev,
      role: "AGENT",
    }));
    setShowLicenseTable(true);
    setUserType("AGENT");
    handleClose();
  };

  const renderProfileCompletionAlert = () => {
    console.log("renderProfileCompletionAlert");
    return (
      <>
        <Container className="mt-12">
          <div className="form-group">
            <div className="profile-progress-bar">
              <div>
                <span className="fa fa-check fa-xs profile-success-symbol">
                  &nbsp;
                </span>
              </div>
              <div className="stage-success"></div>
              <div>
                <span className="glyphicon  profile-progress-symbol">
                  &nbsp;
                </span>
              </div>
              <div className="stage-inprogress"></div>
              <div>
                <span className="glyphicon profile-gray-symbol">&nbsp;</span>
              </div>
            </div>
            <div className="profile-progress-titles">
              <div className="globalAlertsTxt">Registration</div>
              <div className="globalAlertsTxt">Profile Completion</div>
              <div className="globalAlertsTxt">Idology Verification</div>
            </div>
          </div>
          <div className="d-flex justify-content-between align-items-center mb-2">
            <h4 className="profileInfoHeading">Profile Information</h4>
          </div>
          {/* <ConfirmationModal
                           isOpen={showConfirmModal}
                           onClose={handleCancelRoleChange}
                           onConfirm={handleConfirmRoleChange}
                           message={getConfirmationMessage()}
                           title="Change Role"
                         /> */}
          <form onSubmit={handleUserFormSubmit}>
            <InputField
              girdType={Col}
              label="I am a"
              type="radio"
              placeholder="Select a role"
              className={"align-items-center mb-3 globalAlertsTxt"}
              width="100%"
              required={true}
              name="role"
              selected={userType || ""}
              options={[
                { value: "BUYR", label: "Buyer" },
                { value: "AGENT", label: "Agent" },
              ]}
              onChange={(e) => handleRoleChange(e)}
            />
            <div className="row">
              {formDetails?.map((item, index) => {
                return (
                  <InputField
                    disabled={item.name === "emailId" ? true : false}
                    className={"mb-6 globalAlertsTxt"}
                    key={index}
                    placeholder={item.placeholder}
                    type={item.type}
                    required={item.required}
                    width="100%"
                    error={errors[item.name]}
                    // isEditButtonEnabled={item.editLink}
                    options={item.options}
                    // onEdit={handleEmailModalOpen}
                    value={formData[item.name] || ""} // Add this line
                    onChange={(e) => {
                      const { name, value } = e.target;
                      // Check if this is the state field
                      if (item.name === "state") {
                        handleStateChange(e);
                      }
                      if (item.name === "city") {
                        handleCityChange(e);
                      }
                      else {
                        setFormData({
                          ...formData,
                          [item.name]: e.target.value,
                        });
                        setErrors((prevErrors) => ({
                          ...prevErrors,
                          [name]: "",
                        }));
                      }
                    }}
                    handleBlur={(e) => {
                      console.log('handleBlur -> ', e.target);
                      handleBlur(e, item);
                    }}
                  />
                );
              })}
            </div>
          </form>

          {profileInfo?.userDetails?.showSmsOptInOptionFlag === true && (
            <div className="mt-2">
              <p className="globalAlertsTxt">
                Subscribe for text messages / alerts
              </p>
              <Form.Control
                id="alerts-sms-opt-in-select"
                className="custom-dropdown globalAlertsTxt"
                onChange={handleSmSOptChange}
                value={smsOptInStatus}
                as="select"
                style={{
                  width: "85%",

                  appearance: "none",
                  background: `url('data:image/svg+xml;utf8,<svg fill="none" stroke="%23777" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M6 9l6 6 6-6"></path></svg>') no-repeat right `,
                }}
              >
                <option value="Yes">Yes</option>
                <option value="No"> No</option>
              </Form.Control>
              <p className="my-3 globalAlertsTxt">
                Do you want to receive important text message notifications
                related to your bids?
              </p>
              {smsOptInStatus === 'Yes' &&

                <p className="globalAlertsTxt">
                  I agree to be contacted according to these
                  <a
                    href="/about/terms"
                    id="alerts-terms-link"
                    target="_blank"
                    rel="noopener noreferrer"

                    style={{ marginLeft: "5px", color: "#0d6efd" }}
                  >
                    Terms & Conditions.{" "}
                  </a>
                  This consent includes receiving autodialed calls and
                  texts from Altisource Online Auction, Inc. and its
                  affiliates. I understand that this consent is not a
                  condition to receiving any services.
                </p>
              }

            </div>
          )}
          {showLicenseTable || userType == "AGENT" ? (
            <div className="licenseInfoTable">
              {/* License information */}
              <div className="license-info">
                <Row className="d-flex justify-content-between align-items-center">
                  <Col sm="auto">
                    <h4 className="required-label">License Information</h4>
                  </Col>
                  <Col sm="auto">
                    <Button
                      variant="secondary"
                      id="alerts-add-license-btn"
                      style={{
                        borderRadius: "50px",
                        display: "flex",
                        alignItems: "center",
                      }}
                      onClick={() => {
                        openAddLicenseModal("indv")
                        trackButtonClick({
                          eventName: "alert_add_license_click",
                          eventCategory: "Profile Forms Global Alerts",
                          eventLabel: "Agent|addLicense"
                        })
                      }}
                    >
                      <FaPlus style={{ marginRight: "5px" }} />
                      Add License
                    </Button>
                    <br></br>
                  </Col>

                  {
                    (errors?.licenseEmpty?.length > 0 && licenseEmpty) && <p className="text-danger">{errors?.licenseEmpty}</p>
                  }
                  <LicenseInfoTable
                    onEditClick={handleEditClick}
                    onDeleteLicense={handleDeleteLicense}
                    agentLicenseInfo={agentLicenseInfo}
                    type="Indv"
                  />
                </Row>
                <DynamicModal
                  show={showModal}
                  location={"alert"}
                  handleClose={() => {
                    setShowModal(false);
                    setErrorSubmitting("");
                  }}
                  fields={licenseFields}
                  onSubmit={
                    licenseType == "Indv"
                      ? handleLicenseFormSubmit
                      : handleCorpLicenseFormSubmit
                  }
                  title={
                    modalMode == "Add"
                      ? `Add License`
                      : `Update License Details`
                  }
                  initialValues={
                    licenseType == "Indv"
                      ? initialValues
                      : initalCorpValues
                  }
                  mode={modalMode}
                  errorSubmitting={errorSubmitting}
                  setLicenseCityDropDown={setLicenseCityDropDown}
                  licenseLoading={licenseLoading}
                />
                {/* <DynamicModal
                  enforceFocus={true}
                  show={showModal}
                  handleClose={() => {
                    setShowModal(false);
                  }}
                  fields={licenseFields}
                  onSubmit={handleLicenseFormSubmit}
                  title={
                    modalMode == "Add"
                      ? "Add New License"
                      : "Update License Details"
                  }
                  initialValues={initialValues}
                  mode={modalMode}
                /> */}
              </div>

              {/* corporate License Information */}
              <div className="license-info">
                <Row className="d-flex justify-content-between align-items-center">
                  <Col sm="auto" style={{ width: '50%' }}>
                    <h4 className="required-label">
                      {" "}
                      Corporate License Information
                    </h4>
                  </Col>
                  <Col sm="auto">
                    <Button
                      variant="secondary"
                      id="alerts-add-corp-license-btn"
                      style={{
                        borderRadius: "50px",
                        display: "flex",
                        alignItems: "center",
                      }}
                      onClick={() => {
                        openAddLicenseModal("Corp")
                        trackButtonClick({
                          eventName: "add_link_click",
                          eventCategory: "Profile Forms Global Alerts",
                          eventLabel: "Agent|regular"
                        })
                      }}
                    >
                      <FaPlus style={{ marginRight: "5px" }} />
                      Add License
                    </Button>
                    <br></br>
                  </Col>
                  <LicenseInfoTable
                    onEditClick={handleEditCorpClick}
                    agentLicenseInfo={agentCorpLicenseInfo}
                    onDeleteLicense={handleDeleteCorpLicense}
                    type="Corp"
                  />
                </Row>
                {/* <DynamicModal
                  show={showModal}
                  handleClose={() => {
                    setShowModal(false);
                    setErrorSubmitting("");
                  }}
                  fields={licenseFields}
                  onSubmit={
                    licenseType == "Indv"
                      ? handleLicenseFormSubmit
                      : handleCorpLicenseFormSubmit
                  }
                  title={
                    modalMode == "Add"
                      ? `Add New License`
                      : `Update License Details`
                  }
                  initialValues={
                    licenseType == "Indv"
                      ? initialValues
                      : initalCorpValues
                  }
                  mode={modalMode}
                  errorSubmitting={errorSubmitting}
                  setLicenseCityDropDown={setLicenseCityDropDown}
                /> */}


                {/* <DynamicModal
                  show={showModal}
                  handleClose={() => {
                    setShowModal(false);
                    setEditingLicense(null);
                  }}
                  fields={licenseFields}
                  mode={modalMode}
                  title={editingLicense ? "Edit License" : "Add License"}
                  initialValues={editingLicense || {}}
                  handleUpdate={(e) => handleLicenseUpdate(e)}
                /> */}
              </div>
            </div>
          ) : (
            ""
          )}
          <Button
            variant="submit"
            id="alerts-save-profile-btn"
            className="btn btn-primary  px-4 shadow-sm"
            style={{
              width: "100%",
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
            onClick={handleUserFormSubmit}
            disabled={isLoading}
          >
            {isLoading ? "saving" : "Save"}
          </Button>
          <br></br>

          <div className="confirmationModel">
            <Modal show={showConfirmation} onHide={handleClose}>
              <Modal.Header closeButton className="license-title">
                User Role
              </Modal.Header>
              <Modal.Body>
                <p className="text-center">
                  Are you sure you want to Switch Roles?
                </p>
              </Modal.Body>
              <Modal.Footer className="justify-content-center">
                <button
                  id="alerts-confirm-role-change-btn"
                  onClick={handleChangeAgent}
                  className="btn hubzu-btn-thm rounded"
                >
                  Yes
                </button>
                <button id="alerts-cancel-role-change-btn" onClick={handleClose} className="license-delete-btn">
                  No
                </button>
              </Modal.Footer>
            </Modal>
          </div>
        </Container>
      </>
    );
  };

  const renderAlerts = () => {
    return (
      <>

        {shouldShowProfile() === true ? (
          renderProfileCompletionAlert()
        ) : isIdologyVerified === false ||
          alertsData?.idologyVerificationRequired === true ? (
          renderIdeolodyScreen()
        ) : alerts?.length > 0 ? (
          <FlatList
            list={alerts}
            data={alerts}
            renderItem={(item) => <AlertsCards {...item} />}
            key={(item) => item.propertyId}
            extraData={alerts}
          // <FlatList
          //   data={alerts}
          //   renderItem={({ item }) => <AlertsCards key={item.propertyId} {...item} />}
          //   keyExtractor={(item) => item.propertyId}
          //   extraData={alerts}
          />
        ) : (
          <>
            {shouldShowProfile() === false && isIdologyVerified === true && (
              <div className="noAlertsView">
                <div className="">
                  <Container className="row ">
                    <HiOutlineBellAlert size={80} />
                    <h2 className="noAlertsTxtHeading center">
                      All Caught Up!
                    </h2>
                    <p className="">You have no new notifications!</p>
                  </Container>
                </div>
              </div>
            )}
          </>
        )}
      </>
    );
  };

  const renderLogin = () => {
    // dispatch(setLoginTab("regsiterTab"))
    return (
      <>
        <LoginSignup isFromAlerts={"Y"} isOtpVerificationModal />
      </>
    );
  };

  return (
    <>
      {
        isLoadingAlerts ?

          <div className="text-center p-4 mt30">
            <div className="mt30 pt30" role="">
                     <div className="mt-4">
                       {[1, 2].map((item) => (
                         <div key={item} className="w-100 mb-3">
                           <ShimmerContentBlock
                             cta
                             card
                             thumbnailWidth={130}
                             thumbnailHeight={100}
                           />
                         </div>
                           ))}
                           </div>
            </div>
          </div>
          :
          <div id="globalProfileContainer">
            {userData?.isUserLoggedIn ? renderAlerts() : renderLogin()}
          </div>
      }
    </>

  );
};
export default Alerts;
